"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var omit = require("lodash.omit");
var react_1 = require("react");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        backgroundColor: styles_1.BackgroundColor.White,
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
};
var getStyle = function (props) { return ([
    componentStyle.base,
    props.elevation && styles_1.elevation[props.elevation],
    props.style,
]); };
var Paper = (function (_super) {
    __extends(Paper, _super);
    function Paper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Paper.prototype.render = function () {
        var otherProps = __rest(omit(this.props, ['elevation', 'style']), []);
        return (React.createElement("div", __assign({ style: getStyle(this.props) }, otherProps), this.props.children));
    };
    Paper.defaultProps = {
        elevation: 1,
    };
    Paper = __decorate([
        Radium
    ], Paper);
    return Paper;
}(react_1.PureComponent));
exports.Paper = Paper;



//////////////////
// WEBPACK FOOTER
// ./src/components/Paper/Paper.tsx
// module id = 321
// module chunks = 0